import React, { type CSSProperties } from "react";
import type { ButtonKey } from "../../constants/gamepad";
import { Button } from "./Button";

interface ActionButtonProps {
  buttonKey: ButtonKey;
  iconConfig: {
    src1x: string;
    src2x: string;
    src3x: string;
  };
  onTouchStart: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onTouchEnd: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onMouseDown: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  onMouseUp: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  buttonKey,
  iconConfig,
  onTouchStart,
  onTouchEnd,
  onMouseDown,
  onMouseUp,
  style = {},
  containerStyle = {},
}) => {
  return (
    <Button
      buttonKey={buttonKey}
      style={{
        ...baseStyles.actionButton,
        ...containerStyle,
        ...style,
      }}
      iconConfig={iconConfig}
      onTouchStart={(e, buttonKey) => onTouchStart(e, buttonKey!)}
      onTouchEnd={(e, buttonKey) => onTouchEnd(e, buttonKey!)}
      onMouseDown={(e, buttonKey) => onMouseDown(e, buttonKey!)}
      onMouseUp={(e, buttonKey) => onMouseUp(e, buttonKey!)}
    />
  );
};

const baseStyles: { [key: string]: CSSProperties } = {
  actionButton: {
    position: "absolute",
    width: 48,
    height: 48,
    borderRadius: "50%",
  },
};
